import { HANDLE_OFFLINE } from '../actions';
import moment from 'moment';

const initialState = {  
    offline: [],
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    manager: "",
    status: [""],
    pageNo: 1,
    workTypeFilter: [""],
    deviceStatus: [""],
    area: "",
    search: "",
    customer: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_OFFLINE:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  } 
}
